module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "response radio"
  }, [(_vm.currentResponse.section) ? _c('p', {
    class: {
      'section': true, 'first': _vm.currentResponse.id === 1
    }
  }, [_vm._v("\n        " + _vm._s(_vm.currentResponse.section) + "\n    ")]) : _vm._e(), _vm._v(" "), _c('input', {
    staticClass: "response-input",
    attrs: {
      "type": "radio",
      "name": 'quizz-radio-' + _vm.currentQuestion.id,
      "id": 'quizz-radio-' + _vm.responseId
    },
    domProps: {
      "value": _vm.responseId
    },
    on: {
      "click": _vm.updateValue
    }
  }), _vm._v(" "), _c('label', {
    staticClass: "response-label",
    attrs: {
      "for": 'quizz-radio-' + _vm.responseId
    }
  }, [_vm._v("\n        " + _vm._s(_vm.currentResponse.label) + "\n    ")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-221fc66e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Response.vue
// module id = 17
// module chunks = 0